import React, { PropTypes } from 'react'

import InstaFeed from 'instafeed.js';

class InstagramFeed extends React.Component {
  constructor(props) {
    super(props);
    this.feed = new InstaFeed({
      get: 'user',
      userId: '2014104455',
      clientId: '43963b7c16744e63bc90f0209f3c59de',
      accessToken: '2014104455.1677ed0.ef1495d7190b430ca39d20ed962bc5ea',
      limit: '20',
      //template: '<a className="instagram" href={{link}}><img src={{image}}/></a><p>{{caption}}</p>'
    })
  }
  //TODO: Look into whether Caching is ncessary for these requets. InstaFeed doesnt dispaly on iPhone

  componentDidMount() {
    this.feed.run();
  }

  render () {
    return (
      <section id="instagram-feed">
        <div className="container">
          <div className="box">
            <div className="header">
              <a href="https://www.instagram.com/herbalaktivpeel/">
                <h1>@herbalaktivpeel</h1>
              </a>
            </div>
            <div id="instafeed"></div>
          </div>
        </div>
      </section>
    )
  }
}
//PixelUnion


export default InstagramFeed;



/** WEBPACK FOOTER **
 ** ./src/components/containers/social-media/InstagramFeed.jsx
 **/